import axios from "@/hooks/axios/axios";
import authAxios from "@/hooks/axios/authAxios";
import {
  type IAuthMeResponse,
  type IChangeEmailPayload,
  type IChangeEmailResponse,
  type IChangeNamePayload,
  type IChangeNameResponse,
  type IChangePasswordPayload,
  type IChangePasswordResponse,
  type IForgotPasswordPayload,
  type IForgotPasswordResponse,
  type IRegisterPayload,
  type IRegisterResponse,
  type IResetPasswordPayload,
  type IResetPasswordResponse,
} from "../types/auth.types";

export const getTokenFromCode = async (code: string) => {
  const res = await authAxios.get("/auth/callback", {
    params: { access_token: code },
  });

  return {
    user: res.data.data.user,
    token: res.data.data.token,
    refresh_token: res.data.data.refresh_token,
    provider: res.data.data.provider,
  };
};
export const logoutUser = async (): Promise<void> => {
  await authAxios.post("/auth/google/logout");
};

export const refreshTokenApi = async (refreshToken: string) => {
  const res = await authAxios.put("/auth/refresh", {
    refresh_token: refreshToken,
  });
  return res.data;
};

export const loginWithEmail = async (email: string, password: string) => {
  const formData = new URLSearchParams();
  formData.append("email", email);
  formData.append("password", password);

  const res = await authAxios.post("/auth/login", formData, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  return res.data;
};

export const registerUser = async (
  payload: IRegisterPayload,
): Promise<IRegisterResponse> => {
  const { data } = await authAxios.post("/auth/users/register", payload);
  return data;
};

export const forgotPassword = async (
  payload: IForgotPasswordPayload,
): Promise<IForgotPasswordResponse> => {
  const { data } = await authAxios.post("/auth/users/forgot-password", payload);
  return data;
};

export const resetPassword = async (
  payload: IResetPasswordPayload,
): Promise<IResetPasswordResponse> => {
  const { data } = await authAxios.post("/auth/users/reset-password", payload);
  return data;
};

export const changePassword = async (
  payload: IChangePasswordPayload,
): Promise<IChangePasswordResponse> => {
  const { data } = await axios.post("/auth/change-password", payload);
  return data;
};

export const changeEmail = async (
  payload: IChangeEmailPayload,
): Promise<IChangeEmailResponse> => {
  const { data } = await axios.put(`/auth/users/${payload.user_id}`, {
    email: payload.email,
  });
  return data;
};

export const changeName = async (
  payload: IChangeNamePayload,
): Promise<IChangeNameResponse> => {
  const { data } = await axios.put(`/auth/users/profile/${payload.email}`, {
    first_name: payload.first_name,
    last_name: payload.last_name,
  });
  return data;
};

export const getAuthMe = async (): Promise<IAuthMeResponse> => {
  const { data } = await axios.get("/auth/me");
  return data;
};
